import { render } from "./BaseTypeDropdown.vue?vue&type=template&id=274d7dcc&scoped=true&lang=pug"
import script from "./BaseTypeDropdown.vue?vue&type=script&lang=js"
export * from "./BaseTypeDropdown.vue?vue&type=script&lang=js"

import "./BaseTypeDropdown.vue?vue&type=style&index=0&id=274d7dcc&lang=scss&scoped=true"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-274d7dcc"]])

export default __exports__